export const USER_IDLE_THRESHOLD_MS = 10 * 60 * 1000; // 10 minutes
